(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["NPG-FAQ"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.SmokpubFaqBackdrop) return;

  // One controller per FAQ section; the FAQ element owns its lifecycle.
  class SmokpubFaqBackdrop {
    constructor(root) {
      this.root = root;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = true;
      this.x = this.targetX = 50;
      this.y = this.targetY = 22;
      this.raf = 0;
      this.lastTime = 0;
      this.destroyed = false;

      this.onPointerMove = event => {
        // Touch scrolling stays native; touch interaction is a single tap.
        if (event.pointerType === 'mouse' || event.pointerType === 'pen') this.setTarget(event);
      };
      this.onPointerDown = event => {
        if (event.pointerType === 'touch') this.setTarget(event);
      };
      this.onPointerLeave = event => {
        // A tap leaves its light in place; only a hovering pointer recenters.
        if (event.pointerType === 'touch') return;
        if (!this.canFollow()) return;
        this.targetX = 50;
        this.targetY = 22;
        this.schedule();
      };
      this.onVisibility = () => this.refresh();
      this.onMotion = () => {
        if (this.motion.matches) {
          this.x = this.targetX = 50;
          this.y = this.targetY = 22;
          this.paint();
        }
        this.refresh();
      };

      root.addEventListener('pointermove', this.onPointerMove, { passive: true });
      root.addEventListener('pointerdown', this.onPointerDown, { passive: true });
      root.addEventListener('pointerleave', this.onPointerLeave, { passive: true });
      document.addEventListener('visibilitychange', this.onVisibility);
      if (this.motion.addEventListener) this.motion.addEventListener('change', this.onMotion);
      else this.motion.addListener(this.onMotion);

      if ('IntersectionObserver' in window) {
        this.intersection = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.refresh();
        });
        this.intersection.observe(root);
      }
      this.attributes = new MutationObserver(() => this.refresh());
      this.attributes.observe(root, { attributes: true, attributeFilter: ['data-background-mode', 'data-gradient-follow'] });
      this.refresh();
    }

    canAnimate() {
      return !this.destroyed && this.root.isConnected && this.visible && !document.hidden && !this.motion.matches;
    }

    canFollow() {
      const mode = this.root.dataset.backgroundMode;
      return this.canAnimate() && this.root.dataset.gradientFollow === 'true' && (mode === 'spotlight' || mode === 'aurora');
    }

    refresh() {
      this.root.dataset.backgroundActive = String(this.canAnimate());
      if (!this.canFollow()) {
        this.cancel();
        return;
      }
      if (Math.abs(this.targetX - this.x) + Math.abs(this.targetY - this.y) > .05) this.schedule();
    }

    setTarget(event) {
      if (!this.canFollow()) return;
      const bounds = this.root.getBoundingClientRect();
      if (bounds.width < 1 || bounds.height < 1) return;
      this.targetX = Math.max(0, Math.min(100, (event.clientX - bounds.left) / bounds.width * 100));
      this.targetY = Math.max(0, Math.min(100, (event.clientY - bounds.top) / bounds.height * 100));
      this.schedule();
    }

    schedule() {
      if (!this.raf && this.canFollow()) this.raf = requestAnimationFrame(time => this.frame(time));
    }

    frame(time) {
      this.raf = 0;
      if (!this.canFollow()) { this.lastTime = 0; return; }
      const dt = Math.min(50, this.lastTime ? time - this.lastTime : 16);
      const factor = 1 - Math.exp(-dt / 115);
      this.x += (this.targetX - this.x) * factor;
      this.y += (this.targetY - this.y) * factor;
      this.lastTime = time;
      this.paint();
      if (Math.abs(this.targetX - this.x) + Math.abs(this.targetY - this.y) > .05) this.schedule();
      else this.lastTime = 0;
    }

    paint() {
      this.root.style.setProperty('--faq-light-x', this.x.toFixed(2) + '%');
      this.root.style.setProperty('--faq-light-y', this.y.toFixed(2) + '%');
    }

    cancel() {
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.lastTime = 0;
    }

    cleanup() {
      this.destroyed = true;
      this.cancel();
      this.intersection?.disconnect();
      this.attributes?.disconnect();
      this.root.removeEventListener('pointermove', this.onPointerMove);
      this.root.removeEventListener('pointerdown', this.onPointerDown);
      this.root.removeEventListener('pointerleave', this.onPointerLeave);
      document.removeEventListener('visibilitychange', this.onVisibility);
      if (this.motion.removeEventListener) this.motion.removeEventListener('change', this.onMotion);
      else this.motion.removeListener(this.onMotion);
      this.root.dataset.backgroundActive = 'false';
    }
  }

  window.SmokpubFaqBackdrop = SmokpubFaqBackdrop;
})();

(function () {
  'use strict';
  if (!window.customElements || customElements.get('smokpub-pan')) return;

  const DEFAULT_YAW = -Math.PI / 4;
  const ELEVATION = 0.68;
  const CAMERA_UP = Math.sqrt(1 - ELEVATION * ELEVATION);
  // Keep geometry in a theme asset so the Liquid section stays below 256 KB.
  const modelPromises = new Map();
  function loadSourceModel(source) {
    if (!source) return Promise.reject(new Error('Missing model asset URL'));
    const url = new URL(source, document.baseURI).href;
    if (!modelPromises.has(url)) {
      const promise = (async () => {
        if (!window.DecompressionStream) throw new Error('Model decompression unavailable');
        const encoded = await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.async = true;
          const cleanup = () => {
            clearTimeout(timer);
            script.onload = script.onerror = null;
            script.remove();
          };
          const timer = setTimeout(() => {
            cleanup();
            reject(new Error('Model asset load timed out'));
          }, 15000);
          script.onload = () => {
            const value = window.SmokpubPanModelData?.get(url);
            window.SmokpubPanModelData?.delete(url);
            cleanup();
            if (typeof value === 'string' && value.length) resolve(value);
            else reject(new Error('Invalid model asset'));
          };
          script.onerror = () => {
            cleanup();
            reject(new Error('Model asset could not load'));
          };
          document.head.appendChild(script);
        });
        const decoded = atob(encoded);
        const bytes = new Uint8Array(decoded.length);
        for (let i = 0; i < decoded.length; i++) bytes[i] = decoded.charCodeAt(i);
        const stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'));
        const buffer = await new Response(stream).arrayBuffer();
        if (!buffer.byteLength || buffer.byteLength % 132) throw new Error('Invalid model geometry');
        return new Float32Array(buffer);
      })();
      modelPromises.set(url, promise);
      promise.catch(() => {
        if (modelPromises.get(url) === promise) modelPromises.delete(url);
      });
    }
    return modelPromises.get(url);
  }
  const clamp = (value, low, high) => Math.max(low, Math.min(high, value));
  const wrap = angle => Math.atan2(Math.sin(angle), Math.cos(angle));
  const VERTEX = `
    attribute vec3 aPosition;
    attribute vec3 aNormal;
    attribute vec3 aColor;
    attribute vec2 aFinish;
    uniform mat4 uModel;
    uniform mat4 uProjection;
    varying vec3 vPosition;
    varying vec3 vNormal;
    varying vec3 vColor;
    varying vec2 vFinish;
    void main() {
      vec4 world = uModel * vec4(aPosition, 1.0);
      vPosition = world.xyz;
      vNormal = mat3(uModel) * aNormal;
      vColor = aColor;
      vFinish = aFinish;
      gl_Position = uProjection * world;
    }`;
  const FRAGMENT = `
    precision mediump float;
    varying vec3 vPosition;
    varying vec3 vNormal;
    varying vec3 vColor;
    varying vec2 vFinish;
    uniform vec3 uView;
    void main() {
      if (vFinish.x < 0.0) {
        gl_FragColor = vec4(vColor, 1.0);
        return;
      }
      vec3 n = normalize(vNormal);
      vec3 key = normalize(vec3(-3.5, 5.0, 4.2));
      vec3 fill = normalize(vec3(4.0, 3.0, -3.0));
      float diffuse = 0.48 + 0.78 * max(dot(n, key), 0.0)
                           + 0.28 * max(dot(n, fill), 0.0);
      float specular = pow(max(dot(n, normalize(key + uView)), 0.0), vFinish.x);
      float second = pow(max(dot(n, normalize(fill + uView)), 0.0), vFinish.x);
      float edge = pow(1.0 - max(dot(n, uView), 0.0), 3.0);
      float grain = fract(sin(dot(vPosition, vec3(133.1, 271.9, 97.3))) * 43758.5);
      vec3 color = vColor * diffuse * (0.97 + 0.06 * grain);
      color += vec3(0.91, 0.95, 1.0) * vFinish.y * (specular + 0.35 * second);
      color += vec3(0.044, 0.05, 0.06) * edge;
      gl_FragColor = vec4(color, 1.0);
    }`;

  function colorFromHex(value) {
    const hex = /^#[0-9a-f]{6}$/i.test(value || '') ? value : '#25272b';
    return [1, 3, 5].map(offset => parseInt(hex.slice(offset, offset + 2), 16) / 255);
  }

  function multiply(a, b) {
    const result = new Float32Array(16);
    for (let column = 0; column < 4; column++) {
      for (let row = 0; row < 4; row++) {
        for (let k = 0; k < 4; k++) result[column * 4 + row] += a[k * 4 + row] * b[column * 4 + k];
      }
    }
    return result;
  }

  function modelMatrix(yaw, tiltX, tiltZ) {
    const c = Math.cos(yaw), s = Math.sin(yaw);
    const x = Math.cos(tiltX), a = Math.sin(tiltX);
    const z = Math.cos(tiltZ), b = Math.sin(tiltZ);
    const ry = [c, 0, -s, 0, 0, 1, 0, 0, s, 0, c, 0, 0, 0, 0, 1];
    const rx = [1, 0, 0, 0, 0, x, a, 0, 0, -a, x, 0, 0, 0, 0, 1];
    const rz = [z, b, 0, 0, -b, z, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
    return multiply(multiply(rz, rx), ry);
  }

  class SmokpubPan extends HTMLElement {
    static get observedAttributes() { return ['data-color', 'data-follow', 'data-mobile-mode']; }

    connectedCallback() {
      this._mountToken = (this._mountToken || 0) + 1;
      this._initializing = false;
      this.setAttribute('aria-hidden', 'true');
      this._yaw = this._targetYaw = DEFAULT_YAW;
      this._tiltX = this._tiltZ = this._targetX = this._targetZ = 0;
      this._visible = false;
      this._lost = false;
      this._usingTouch = false;
      this._usingMouse = false;
      this._autoResume = 0;
      this._drag = null;
      this._boot = () => {
        if (!this.isConnected || this._canvas) return;
        const canvas = this.querySelector('[data-pan-canvas]');
        if (!canvas) return;
        this._children?.disconnect();
        this._canvas = canvas;
        this.dataset.renderState = 'fallback';
        this._connect();
      };
      this._children = new MutationObserver(this._boot);
      this._children.observe(this, { childList: true, subtree: true });
      this._boot();
    }

    _connect() {
      this._motion = matchMedia('(prefers-reduced-motion: reduce)');
      this._onMotion = () => { this._endTouch(); this._reset(true); };
      this._motion.addEventListener?.('change', this._onMotion);
      if (!this._motion.addEventListener) this._motion.addListener(this._onMotion);
      this._mobile = matchMedia('(hover: none), (pointer: coarse)');
      this._onMobile = () => { this._cancel(); this._dirty = true; this._schedule(); };
      this._mobile.addEventListener?.('change', this._onMobile);
      if (!this._mobile.addEventListener) this._mobile.addListener(this._onMobile);
      this._onPointer = event => {
        if (event.pointerType && event.pointerType !== 'mouse') return;
        this._usingTouch = false;
        this._usingMouse = true;
        if (!this._visible || !this._gl || this._lost || this._motion.matches || this.dataset.follow !== 'true') return;
        const rect = this.getBoundingClientRect();
        const dx = event.clientX - rect.left - rect.width / 2;
        const dy = event.clientY - rect.top - rect.height / 2 - (this._centerOffset || 0);
        if (Math.hypot(dx, dy) < 3) return;
        this._targetYaw = -Math.atan2(dy / ELEVATION, dx);
        this._targetX = clamp(-dy / Math.max(rect.height, 1) * .055, -.08, .08);
        this._targetZ = clamp(dx / Math.max(rect.width, 1) * .055, -.08, .08);
        this._schedule();
      };
      this._onTouchStart = event => {
        if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
        if (this._drag || !event.isPrimary || !this._visible || !this._gl || this._lost || this._motion.matches
          || this._mobileMode() === 'static') return;
        this._usingTouch = true;
        this._usingMouse = false;
        clearTimeout(this._autoTimer);
        this._autoTimer = 0;
        this._drag = { id: event.pointerId, x: event.clientX, y: event.clientY,
          yaw: this._targetYaw, width: Math.max(this.getBoundingClientRect().width, 160), axis: null };
      };
      this._onTouchMove = event => {
        const drag = this._drag;
        if (!drag || drag.id !== event.pointerId) return;
        const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
        if (!drag.axis) {
          if (Math.max(Math.abs(dx), Math.abs(dy)) < 8) return;
          drag.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }
        // touch-action: pan-y allows a vertical swipe to keep scrolling the page.
        if (drag.axis !== 'x') return;
        this._targetYaw = wrap(drag.yaw + dx / drag.width * Math.PI * 2);
        this._targetX = 0;
        this._targetZ = clamp(dx / drag.width * .06, -.06, .06);
        this._schedule();
      };
      this._onTouchEnd = event => {
        if (this._drag?.id === event.pointerId) this._endTouch();
      };
      this._onReset = () => {
        if (this._drag || this._usingTouch || this._mobile?.matches) this._endTouch();
        else this._reset();
      };
      this._onOut = event => {
        if ((!event.pointerType || event.pointerType === 'mouse') && event.relatedTarget === null) this._reset();
      };
      window.addEventListener('pointermove', this._onPointer, { passive: true });
      window.addEventListener('pointerdown', this._onPointer, { passive: true });
      window.addEventListener('pointerout', this._onOut, { passive: true });
      this.addEventListener('pointerdown', this._onTouchStart, { passive: true });
      window.addEventListener('pointermove', this._onTouchMove, { passive: true });
      window.addEventListener('pointerup', this._onTouchEnd, { passive: true });
      window.addEventListener('pointercancel', this._onTouchEnd, { passive: true });
      window.addEventListener('blur', this._onReset);
      this._onVisibility = () => {
        if (document.hidden) {
          this._drag = null;
          this._targetX = this._targetZ = 0;
          clearTimeout(this._autoTimer);
          this._autoTimer = 0;
          this._cancel();
        }
        else { this._dirty = true; this._schedule(); }
      };
      document.addEventListener('visibilitychange', this._onVisibility);
      this._onLost = event => {
        event.preventDefault();
        this._lost = true;
        this._cancel();
        this.dataset.renderState = 'fallback';
      };
      this._onRestored = () => {
        this._releaseGPU();
        this._lost = false;
        if (this._visible) this._initialize();
      };
      this._canvas.addEventListener('webglcontextlost', this._onLost);
      this._canvas.addEventListener('webglcontextrestored', this._onRestored);
      this._onResize = () => { this._dirty = true; this._schedule(); };
      if (window.ResizeObserver) {
        this._resize = new ResizeObserver(this._onResize);
        this._resize.observe(this);
      } else window.addEventListener('resize', this._onResize, { passive: true });
      if (window.IntersectionObserver) {
        this._intersection = new IntersectionObserver(entries => {
          this._visible = entries[entries.length - 1].isIntersecting;
          if (this._visible) {
            if (!this._gl && !this._lost) this._initialize();
            this._dirty = true;
            this._schedule();
          } else this._cancel();
        }, { rootMargin: '60px' });
        this._intersection.observe(this);
      } else {
        this._visible = true;
        this._initialize();
      }
    }

    _initialize() {
      if (this._initializing || this._gl || !this._canvas || this._lost) return;
      this._initializing = true;
      const token = this._mountToken;
      loadSourceModel(this.dataset.modelSrc).then(mesh => {
        if (!this.isConnected || token !== this._mountToken || !this._canvas || this._lost) return;
        this._mesh = mesh;
        this._initializeGPU();
      }).catch(() => {
        if (token === this._mountToken && this.isConnected) this.dataset.renderState = 'fallback';
      }).finally(() => {
        if (token === this._mountToken) this._initializing = false;
      });
    }

    _initializeGPU() {
      try {
        const gl = this._canvas.getContext('webgl', { alpha: true, antialias: true, premultipliedAlpha: false });
        if (!gl) return;
        this._gl = gl;
        this._shaders = [];
        const compile = (type, source) => {
          const shader = gl.createShader(type);
          if (!shader) throw new Error('Shader allocation failed');
          this._shaders.push(shader);
          gl.shaderSource(shader, source);
          gl.compileShader(shader);
          if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) throw new Error('Shader compilation failed');
          return shader;
        };
        this._program = gl.createProgram();
        if (!this._program) throw new Error('Program allocation failed');
        gl.attachShader(this._program, compile(gl.VERTEX_SHADER, VERTEX));
        gl.attachShader(this._program, compile(gl.FRAGMENT_SHADER, FRAGMENT));
        gl.linkProgram(this._program);
        if (!gl.getProgramParameter(this._program, gl.LINK_STATUS)) throw new Error('Program linking failed');
        gl.useProgram(this._program);
        this._buffer = gl.createBuffer();
        if (!this._buffer) throw new Error('Buffer allocation failed');
        gl.bindBuffer(gl.ARRAY_BUFFER, this._buffer);
        this._upload();
        let offset = 0;
        [['aPosition', 3], ['aNormal', 3], ['aColor', 3], ['aFinish', 2]].forEach(([name, size]) => {
          const location = gl.getAttribLocation(this._program, name);
          if (location < 0) throw new Error('Missing shader attribute');
          gl.enableVertexAttribArray(location);
          gl.vertexAttribPointer(location, size, gl.FLOAT, false, 44, offset * 4);
          offset += size;
        });
        this._uniforms = ['uModel', 'uProjection', 'uView'].map(name => gl.getUniformLocation(this._program, name));
        gl.uniform3f(this._uniforms[2], 0, ELEVATION, CAMERA_UP);
        gl.enable(gl.DEPTH_TEST);
        gl.clearColor(0, 0, 0, 0);
        this._dirty = true;
        this._schedule();
      } catch (_) {
        this._releaseGPU();
        this.dataset.renderState = 'fallback';
      }
    }

    _upload() {
      let data = this._mesh;
      if (!data) throw new Error('Source model unavailable');
      if (this.dataset.color && this.dataset.color.toLowerCase() !== '#25272b') {
        data = data.slice();
        const tint = colorFromHex(this.dataset.color);
        const reference = colorFromHex('#25272b');
        for (let i = 0; i < data.length; i += 11) {
          if (Math.max(data[i + 6], data[i + 7], data[i + 8]) >= .35) continue;
          for (let channel = 0; channel < 3; channel++) {
            data[i + 6 + channel] = Math.min(1, data[i + 6 + channel] * tint[channel] / reference[channel]);
          }
        }
      }
      this._gl.bindBuffer(this._gl.ARRAY_BUFFER, this._buffer);
      this._gl.bufferData(this._gl.ARRAY_BUFFER, data, this._gl.STATIC_DRAW);
      this._count = data.length / 11;
    }

    _reset(immediate = false) {
      this._targetYaw = DEFAULT_YAW;
      this._targetX = this._targetZ = 0;
      if (immediate || this._motion?.matches) {
        this._yaw = DEFAULT_YAW;
        this._tiltX = this._tiltZ = 0;
      }
      this._dirty = true;
      this._schedule();
    }

    _mobileMode() {
      return ['auto', 'static'].includes(this.dataset.mobileMode) ? this.dataset.mobileMode : 'drag';
    }

    _endTouch() {
      this._drag = null;
      // Keep the user's final angle; only the small drag tilt settles back to level.
      this._targetX = this._targetZ = 0;
      this._dirty = true;
      clearTimeout(this._autoTimer);
      this._autoTimer = 0;
      if (this._mobileMode() === 'auto' && !this._motion?.matches) {
        this._autoResume = performance.now() + 1200;
        this._autoTimer = setTimeout(() => { this._autoTimer = 0; this._schedule(); }, 1200);
      }
      this._schedule();
    }

    _autoRotate(time) {
      return this._mobileMode() === 'auto' && ((this._mobile?.matches && !this._usingMouse) || this._usingTouch)
        && !this._motion.matches && !this._drag && time >= (this._autoResume || 0);
    }

    _schedule() {
      if (!this._raf && this.isConnected && this._visible && this._gl && !this._lost && !document.hidden) {
        this._raf = requestAnimationFrame(time => this._frame(time));
      }
    }

    _frame(time) {
      this._raf = 0;
      if (!this.isConnected || !this._visible || !this._gl || this._lost || document.hidden) return;
      const elapsed = Math.min(time - (this._lastTime || time - 16), 40);
      const auto = this._autoRotate(time);
      if (auto) this._targetYaw = wrap(this._targetYaw + elapsed / 25000 * Math.PI * 2);
      const factor = 1 - Math.exp(-elapsed / 82);
      const delta = wrap(this._targetYaw - this._yaw);
      this._yaw = wrap(this._yaw + delta * factor);
      this._tiltX += (this._targetX - this._tiltX) * factor;
      this._tiltZ += (this._targetZ - this._tiltZ) * factor;
      this._lastTime = time;
      const moving = Math.abs(delta) > .0005 || Math.abs(this._targetX - this._tiltX) > .0001
        || Math.abs(this._targetZ - this._tiltZ) > .0001;
      try {
        const gl = this._gl, rect = this.getBoundingClientRect();
        if (rect.width < 1 || rect.height < 1) return;
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        const width = Math.max(1, Math.round(rect.width * dpr));
        const height = Math.max(1, Math.round(rect.height * dpr));
        if (this._canvas.width !== width || this._canvas.height !== height) {
          this._canvas.width = width;
          this._canvas.height = height;
        }
        const halfHeight = Math.max(1.42, 1.82 / (width / height));
        const halfWidth = halfHeight * width / height;
        this._centerOffset = .11 * CAMERA_UP / halfHeight * rect.height / 2;
        const projection = new Float32Array([1 / halfWidth, 0, 0, 0,
          0, CAMERA_UP / halfHeight, -ELEVATION / 4, 0,
          0, -ELEVATION / halfHeight, -CAMERA_UP / 4, 0,
          0, -.11 * CAMERA_UP / halfHeight, 0, 1]);
        gl.viewport(0, 0, width, height);
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
        gl.useProgram(this._program);
        gl.uniformMatrix4fv(this._uniforms[0], false, modelMatrix(this._yaw, this._tiltX, this._tiltZ));
        gl.uniformMatrix4fv(this._uniforms[1], false, projection);
        gl.drawArrays(gl.TRIANGLES, 0, this._count);
        if (gl.getError() !== gl.NO_ERROR) throw new Error('WebGL draw failed');
        this.dataset.renderState = 'ready';
        this._dirty = false;
      } catch (_) {
        this._releaseGPU();
        this.dataset.renderState = 'fallback';
        return;
      }
      if ((moving || auto) && !this._motion.matches) this._schedule();
      else this._lastTime = 0;
    }

    attributeChangedCallback(name, before, after) {
      if (before === after) return;
      if (name === 'data-follow' && after !== 'true') this._reset(true);
      if (name === 'data-mobile-mode' && this._canvas) {
        this._endTouch();
        this._cancel();
        this._dirty = true;
        this._schedule();
      }
      if (name === 'data-color' && this._gl && !this._lost) {
        try { this._upload(); this._dirty = true; this._schedule(); }
        catch (_) { this._releaseGPU(); this.dataset.renderState = 'fallback'; }
      }
    }

    _cancel() {
      if (this._raf) cancelAnimationFrame(this._raf);
      this._raf = 0;
      this._lastTime = 0;
    }

    _releaseGPU() {
      this._cancel();
      if (this._gl) {
        if (this._buffer) this._gl.deleteBuffer(this._buffer);
        if (this._program) this._gl.deleteProgram(this._program);
        this._shaders?.forEach(shader => this._gl.deleteShader(shader));
      }
      this._gl = this._buffer = this._program = this._uniforms = null;
      this._shaders = [];
    }

    disconnectedCallback() {
      this._mountToken = (this._mountToken || 0) + 1;
      this._initializing = false;
      this._children?.disconnect();
      this._intersection?.disconnect();
      this._resize?.disconnect();
      window.removeEventListener('resize', this._onResize);
      window.removeEventListener('pointermove', this._onPointer);
      window.removeEventListener('pointerdown', this._onPointer);
      window.removeEventListener('pointerout', this._onOut);
      this.removeEventListener('pointerdown', this._onTouchStart);
      window.removeEventListener('pointermove', this._onTouchMove);
      window.removeEventListener('pointerup', this._onTouchEnd);
      window.removeEventListener('pointercancel', this._onTouchEnd);
      window.removeEventListener('blur', this._onReset);
      document.removeEventListener('visibilitychange', this._onVisibility);
      this._motion?.removeEventListener?.('change', this._onMotion);
      if (this._motion && !this._motion.removeEventListener) this._motion.removeListener(this._onMotion);
      this._mobile?.removeEventListener?.('change', this._onMobile);
      if (this._mobile && !this._mobile.removeEventListener) this._mobile.removeListener(this._onMobile);
      clearTimeout(this._autoTimer);
      this._autoTimer = 0;
      this._drag = null;
      this._canvas?.removeEventListener('webglcontextlost', this._onLost);
      this._canvas?.removeEventListener('webglcontextrestored', this._onRestored);
      this._releaseGPU();
      this._canvas = null;
    }
  }

  customElements.define('smokpub-pan', SmokpubPan);
})();


(() => {
  if (!window.customElements || customElements.get('smokpub-faq')) return;

  class SmokpubFaq extends HTMLElement {
    constructor() {
      super();
      this.handleToggle = this.handleToggle.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
    }

    connectedCallback() {
      this._backdrop ||= new window.SmokpubFaqBackdrop(this);
      this.addEventListener('toggle', this.handleToggle, true);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
    }

    disconnectedCallback() {
      this._backdrop?.cleanup();
      this._backdrop = null;
      this.removeEventListener('toggle', this.handleToggle, true);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }

    closeOthers(selected) {
      if (this.dataset.singleOpen !== 'true') return;
      this.querySelectorAll('[data-sp-faq-item][open]').forEach(item => {
        if (item !== selected) item.open = false;
      });
    }

    handleToggle(event) {
      const item = event.target;
      // Native details grouping works without JavaScript in current browsers.
      // The listener also provides grouping in browsers without details.name.
      if (item.matches('[data-sp-faq-item]') && item.open) this.closeOthers(item);
    }

    handleBlockSelect(event) {
      if (!(event.target instanceof Element) || !this.contains(event.target)) return;
      const item = event.target.closest('[data-sp-faq-item]');
      if (!item) return;
      this.closeOthers(item);
      item.open = true;
    }
  }

  customElements.define('smokpub-faq', SmokpubFaq);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["box-2"] && !Shopify.designMode) return;
  try {
    

  (() => {
    const sectionSelector = '[data-td-feature-stack]';

    const initializeSection = (section) => {
      if (!section || section.dataset.motionInitialized === 'true') return;

      section.dataset.motionInitialized = 'true';

      const rows = Array.from(
        section.querySelectorAll('[data-td-reveal]')
      );

      const reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (
        reduceMotion ||
        !('IntersectionObserver' in window)
      ) {
        rows.forEach((row) => row.classList.add('is-visible'));
        return;
      }

      section.classList.add('is-motion-ready');

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const row = entry.target;

            const currentTop =
              entry.boundingClientRect.top;

            const previousTop =
              Number(row.dataset.lastViewportTop);

            const hasPreviousTop =
              Number.isFinite(previousTop);

            const enterDirection =
              hasPreviousTop &&
              currentTop > previousTop
                ? 'up'
                : 'down';

            row.dataset.lastViewportTop =
              String(currentTop);

            if (entry.isIntersecting) {
              row.dataset.enterDirection =
                enterDirection;

              requestAnimationFrame(() => {
                row.classList.add('is-visible');
              });

              return;
            }

            const isOutsideViewport =
              entry.boundingClientRect.bottom < 0 ||
              entry.boundingClientRect.top >
                window.innerHeight;

            if (isOutsideViewport) {
              row.classList.remove('is-visible');
            }
          });
        },
        {
          threshold: 0.18,
          rootMargin: '0px 0px -8% 0px'
        }
      );

      rows.forEach((row) => {
        observer.observe(row);
      });

      section.tdFeatureStackCleanup = () => {
        observer.disconnect();
      };
    };

    const initializeWithin = (root) => {
      if (
        root.matches &&
        root.matches(sectionSelector)
      ) {
        initializeSection(root);
      }

      root
        .querySelectorAll(sectionSelector)
        .forEach(initializeSection);
    };

    initializeWithin(document);

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initializeWithin(event.target);
      }
    );

    document.addEventListener(
      'shopify:section:unload',
      (event) => {
        const section =
          event.target.querySelector(
            sectionSelector
          );

        if (
          section &&
          section.tdFeatureStackCleanup
        ) {
          section.tdFeatureStackCleanup();
        }
      }
    );
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["box-3"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('makimate-story-drag-motion')) {
  customElements.define('makimate-story-drag-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.root = this.closest('.makimate-story');
      if (!this.root) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.track = this.root.querySelector('.makimate-story__grid');
      this.controls = this.root.querySelector('.makimate-story__controls');
      this.previous = this.root.querySelector('[data-story-slider-previous]');
      this.next = this.root.querySelector('[data-story-slider-next]');
      this.items = [...this.root.querySelectorAll('[data-story-reveal]')];
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      };
      window.addEventListener('scroll', this.schedule, {passive:true, signal});
      window.addEventListener('resize', this.schedule, {passive:true, signal});
      window.addEventListener('pageshow', this.schedule, {signal});
      this.reduced.addEventListener('change', this.schedule, {signal});
      this.root.addEventListener('focusin', this.schedule, {signal});
      this.root.addEventListener('focusout', this.schedule, {signal});
      this.root.addEventListener('load', this.schedule, {capture:true, signal});
      this.root.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.makimate-story__card');
        if (card && this.track) {
          this.track.scrollTo({left:this.track.scrollLeft + card.getBoundingClientRect().left - this.track.getBoundingClientRect().left, behavior:'instant'});
        }
        this.editorSelected = true;
        this.schedule();
      }, {signal});
      this.root.addEventListener('shopify:block:deselect', () => {
        this.editorSelected = false;
        this.schedule();
      }, {signal});
      if (this.track && this.previous && this.next) {
        this.previous.addEventListener('click', () => this.scrollCard(-1), {signal});
        this.next.addEventListener('click', () => this.scrollCard(1), {signal});
        this.track.addEventListener('scroll', this.schedule, {passive:true, signal});
        this.track.addEventListener('pointerdown', event => this.startDrag(event), {signal});
        window.addEventListener('pointermove', event => this.moveDrag(event), {passive:false, signal});
        window.addEventListener('pointerup', event => this.finishDrag(event), {signal});
        window.addEventListener('pointercancel', event => this.finishDrag(event, true), {signal});
        this.track.addEventListener('lostpointercapture', event => this.finishDrag(event, true), {signal});
        window.addEventListener('blur', () => { if (this.drag) this.finishDrag({pointerId:this.drag.id}, true); }, {signal});
        this.track.addEventListener('dragstart', event => event.preventDefault(), {signal});
        this.track.addEventListener('click', event => {
          if (event.detail !== 0 && performance.now() < (this.suppressDragClickUntil || 0)) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.suppressDragClickUntil = 0;
          }
        }, {capture:true, signal});
      }
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.resizeObserver.observe(this.root);
        this.items.forEach(item => this.resizeObserver.observe(item));
      }
      this.update();
      this.root.dataset.storyMotionReady = 'true';
    }
    progress(top, viewport, distance) {
      // Stable outer wrappers are measured; only their children move.
      const range = Math.min(distance, viewport * .4);
      const linear = Math.max(0, Math.min(1, (viewport * .9 - top) / range));
      return linear * linear * (3 - 2 * linear);
    }
    update() {
      const viewport = window.innerHeight;
      const distance = Number(this.root.dataset.storyScrollDistance) || 200;
      const disabled = this.root.dataset.storyMotion === 'false' || this.reduced.matches;
      const states = this.items.map(item => {
        const gallery = item.dataset.storyReveal === 'gallery';
        const forceVisible = disabled || item.contains(document.activeElement) ||
          (gallery && (this.root.dataset.storyGalleryMotion === 'false' || this.editorSelected || this.drag?.moved));
        return {item, progress:forceVisible ? 1 : this.progress(item.getBoundingClientRect().top, viewport, distance)};
      });
      states.forEach(({item, progress}) => item.style.setProperty('--story-reveal', progress.toFixed(4)));
      if (this.track && this.controls && this.previous && this.next) {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const overflow = max > 1;
        this.track.dataset.draggable = String(overflow);
        this.controls.hidden = !overflow;
        this.previous.disabled = !overflow || this.track.scrollLeft <= 1;
        this.next.disabled = !overflow || this.track.scrollLeft >= max - 1;
      }
    }
    startDrag(event) {
      if (event.pointerType !== 'mouse' || event.button !== 0 || event.isPrimary === false || this.track.scrollWidth <= this.track.clientWidth + 1) return;
      if (event.target.closest('button,input,textarea,select,[contenteditable="true"]')) return;
      this.suppressDragClickUntil = 0;
      this.drag = {id:event.pointerId, x:event.clientX, y:event.clientY, start:this.track.scrollLeft, dx:0, moved:false};
    }
    moveDrag(event) {
      const drag = this.drag;
      if (!drag || event.pointerId !== drag.id) return;
      if (event.buttons === 0) { this.finishDrag(event, true); return; }
      const dx = event.clientX - drag.x;
      const dy = event.clientY - drag.y;
      if (!drag.moved) {
        if (Math.abs(dx) < 6) return;
        if (Math.abs(dy) > Math.abs(dx)) { this.drag = null; return; }
        drag.moved = true;
        this.track.classList.add('is-dragging');
        try { this.track.setPointerCapture(event.pointerId); } catch (_) {}
      }
      event.preventDefault();
      drag.dx = dx;
      this.track.scrollLeft = Math.max(0, Math.min(this.track.scrollWidth - this.track.clientWidth, drag.start - dx));
      this.schedule();
    }
    snapPoints() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const left = this.track.getBoundingClientRect().left;
      const points = [...this.track.querySelectorAll('.makimate-story__card')].map(card =>
        Math.max(0, Math.min(max, this.track.scrollLeft + card.getBoundingClientRect().left - left)));
      return [...new Set([0, ...points, max])].sort((a,b) => a-b);
    }
    finishDrag(event, cancelled = false) {
      const drag = this.drag;
      if (!drag || event.pointerId !== drag.id) return;
      this.drag = null;
      if (!drag.moved) return;
      this.suppressDragClickUntil = performance.now() + 450;
      const points = this.snapPoints();
      const nearest = value => points.reduce((best, point, i) => Math.abs(point - value) < Math.abs(points[best] - value) ? i : best, 0);
      const start = nearest(drag.start);
      let destination = nearest(this.track.scrollLeft);
      const threshold = Math.min(80, this.track.clientWidth * .15);
      if (!cancelled && destination === start && Math.abs(drag.dx) >= threshold) {
        destination = Math.max(0, Math.min(points.length - 1, start + (drag.dx < 0 ? 1 : -1)));
      }
      this.track.classList.remove('is-dragging');
      try {
        if (this.track.hasPointerCapture(drag.id)) this.track.releasePointerCapture(drag.id);
      } catch (_) {}
      this.track.scrollTo({left:points[destination], behavior:this.reduced.matches ? 'instant' : 'smooth'});
      this.schedule();
    }

    scrollCard(direction) {
      const card = this.track.querySelector('.makimate-story__card');
      const gap = Number.parseFloat(window.getComputedStyle(this.track).gap) || 0;
      const width = card ? card.getBoundingClientRect().width : this.track.clientWidth;
      this.track.scrollBy({left:direction * (width + gap), behavior:this.reduced.matches ? 'instant' : 'smooth'});
    }
    disconnectedCallback() {
      this.drag = null;
      this.track?.classList.remove('is-dragging');
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      if (this.root) delete this.root.dataset.storyMotionReady;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["npg-2in1"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cook-details-media-boundary')) {
  customElements.define('cook-details-media-boundary', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      if (!this.querySelector('[data-next]')) {
        if (!this.readyObserver) {
          this.readyObserver = new MutationObserver(() => {
            if (!this.querySelector('[data-next]')) return;
            this.readyObserver.disconnect();
            this.readyObserver = null;
            this.connectedCallback();
          });
          this.readyObserver.observe(this, {childList:true,subtree:true});
        }
        return;
      }
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.scenes = [...this.querySelectorAll('[data-scene]')];
      this.active = this.active ?? (Number(this.dataset.initial) === 1 ? 1 : 0);
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.desktop = window.matchMedia('(min-width: 750px)');
      this.videos = [...this.querySelectorAll('video')];
      this.mediaVisible = false;
      this.videos.forEach(video => {
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;
        video.controls = false;
        video.removeAttribute('controls');
      });
      this.desktop.addEventListener('change', () => this.syncVideos(), {signal});
      document.addEventListener('visibilitychange', () => this.syncVideos(), {signal});
      this.addEventListener('pointerdown', () => this.syncVideos(), {signal});
      this.addEventListener('keydown', () => this.syncVideos(), {signal});
      this.mediaObserver = new IntersectionObserver(entries => {
        this.mediaVisible = entries[0].isIntersecting && entries[0].intersectionRatio >= .1;
        this.syncVideos();
      }, {threshold:[0,.1]});
      this.mediaObserver.observe(this.querySelector('.cdt__media'));
      this.settleUntil = 0;
      this.querySelector('[data-prev]').addEventListener('click', () => this.select(0, true), {signal});
      this.querySelector('[data-next]').addEventListener('click', () => this.select(1, true), {signal});
      this.addEventListener('keydown', event => {
        if (event.ctrlKey || event.metaKey || event.altKey || event.target.closest('input,textarea,select,[contenteditable=true]')) return;
        let next;
        if (event.key === 'ArrowLeft') next = 0;
        if (event.key === 'ArrowRight') next = 1;
        if (next !== undefined) { event.preventDefault(); this.select(next, true); }
      }, {signal});
      // Watch the incoming wheel delta, including events originating just outside this section.
      window.addEventListener('wheel', event => this.onWheel(event), {passive:false,signal});
      const media = this.querySelector('.cdt__media');
      media.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch' && event.isPrimary) this.touch = {x:event.clientX,y:event.clientY};
      }, {signal});
      media.addEventListener('pointerup', event => {
        if (!this.touch) return;
        const dx = event.clientX - this.touch.x, dy = event.clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)*1.4) this.select(dx<0?1:0, true);
      }, {signal});
      media.addEventListener('pointercancel', () => { this.touch = null; }, {signal});
      this.observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) { this.classList.add('cdt--entered'); this.observer.disconnect(); }
      }, {threshold:.1});
      this.observer.observe(this);
      this.select(this.active);
    }
    shouldPlayVideo(video) {
      return Boolean(this.controller && this.mediaVisible && !document.hidden &&
        video.closest('[data-scene]')?.classList.contains('is-active') &&
        video.closest('[data-device]')?.dataset.device === (this.desktop.matches ? 'desktop' : 'mobile'));
    }
    syncVideos() {
      (this.videos || []).forEach(video => {
        if (!this.shouldPlayVideo(video)) { video.pause(); return; }
        video.muted = true;
        const attempt = video.play();
        if (attempt && typeof attempt.then === 'function') {
          attempt.then(() => { if (!this.shouldPlayVideo(video)) video.pause(); }).catch(() => {});
        }
      });
    }
    wheelCapture(pixels, now) {
      if (!this.controller || !this.desktop.matches || !this.getClientRects().length) return null;
      const rect = this.getBoundingClientRect();
      const viewport = window.innerHeight;
      if (rect.height <= 0) return null;
      const direction = Math.sign(pixels);
      const next = direction > 0 ? 1 : 0;
      // Down: the section bottom meets the viewport bottom.
      // Up: the section top meets the viewport top.
      const offset = direction > 0 ? rect.bottom - viewport : rect.top;
      const distance = offset * direction;
      const visible = rect.bottom > 0 && rect.top < viewport;
      const holding = now < this.settleUntil && direction === this.lastDirection &&
        Math.abs(offset) <= 2;
      if (holding) return {phase:'hold', distance:0};
      if (next === this.active) return null;
      // Only stop at the boundary; the event that arrives there must not change slides.
      if (distance > 2 && distance <= Math.abs(pixels) + 2) {
        return {phase:'arrive', offset, distance};
      }
      if (distance <= 2 && visible) return {phase:'switch', distance:0};
      return null;
    }
    onWheel(event) {
      if (!this.desktop.matches || event.ctrlKey || event.metaKey || event.defaultPrevented || !event.cancelable || Math.abs(event.deltaY)<1 || Math.abs(event.deltaX)>Math.abs(event.deltaY)) return;
      const direction = Math.sign(event.deltaY);
      // Long copy, other scroll containers and dialogs keep native scrolling.
      const target = event.target instanceof Element ? event.target : null;
      if (target?.closest('dialog[open],[aria-modal="true"]')) return;
      for (let node = target; node && node !== document.body && node !== document.documentElement; node = node.parentElement) {
        const overflow = window.getComputedStyle(node).overflowY;
        if (!/(auto|scroll|overlay)/.test(overflow) || node.scrollHeight <= node.clientHeight + 2) continue;
        const remaining = direction > 0 ? node.scrollHeight - node.clientHeight - node.scrollTop : node.scrollTop;
        if (remaining > 2) return;
      }
      const now = performance.now();
      const pixels = event.deltaY * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? window.innerHeight : 1);
      const capture = this.wheelCapture(pixels, now);
      if (!capture) return;
      const first = [...document.querySelectorAll('cook-details-media-boundary')]
        .map(section => ({section, capture:section.wheelCapture?.(pixels, now)}))
        .filter(item => item.capture)
        .sort((a,b) => a.capture.distance - b.capture.distance)[0];
      if (first && first.section !== this) return;
      event.preventDefault();
      if (capture.phase === 'hold') return;
      if (capture.phase === 'arrive') {
        window.scrollBy({top:capture.offset, left:0, behavior:'instant'});
        return;
      }
      this.lastDirection = direction;
      // Release as soon as the transition ends; no extra inertia lock afterward.
      this.settleUntil = now + (this.reduced.matches || this.dataset.motion === 'false' ? 0 : 1000);
      this.select(direction > 0 ? 1 : 0, true);
    }

    select(index, announce = false) {
      const next = index===1?1:0;
      const changed = next!==this.active;
      const outgoing = this.panels[this.active];
      const focusedPanel = outgoing?.contains(document.activeElement);
      this.style.setProperty('--cdt-shift', next===1?'48px':'-48px');
      this.active=next;
      this.panels.forEach((panel,i) => {
        const active=i===this.active;
        panel.classList.toggle('is-active',active);
        panel.setAttribute('aria-hidden',String(!active));
        panel.inert=!active;
        panel.tabIndex=active?0:-1;
        this.scenes[i].classList.toggle('is-active',active);
      });
      this.syncVideos();
      this.querySelector('[data-prev]').disabled=this.active===0;
      this.querySelector('[data-next]').disabled=this.active===1;
      this.querySelector('.cdt__image-index').innerHTML=`0${this.active+1} <span>/ 02</span>`;
      if (changed && focusedPanel) this.panels[this.active].focus({preventScroll:true});
      if (announce && changed) this.querySelector('[data-status]').textContent=this.panels[this.active].querySelector('.cdt__title').textContent;
    }
    disconnectedCallback() {
      this.mediaVisible=false;
      this.mediaObserver?.disconnect();
      (this.videos || []).forEach(video => video.pause());
      this.controller?.abort();
      this.controller=null;
      this.readyObserver?.disconnect();
      this.readyObserver=null;
      this.observer?.disconnect();
      this.touch=null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["npg-app"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('recipes-app')) {
    customElements.define('recipes-app', class extends HTMLElement {
      connectedCallback() {
        if (this._controller) return;
        // The second instance may connect before the HTML parser reaches its children.
        if (!this.querySelector('[data-next]')) {
          if (!this._readyObserver) {
            this._readyObserver = new MutationObserver(() => {
              if (!this.querySelector('[data-next]')) return;
              this._readyObserver.disconnect();
              this._readyObserver = null;
              this.connectedCallback();
            });
            this._readyObserver.observe(this, { childList:true, subtree:true });
          }
          return;
        }
        this._readyObserver?.disconnect();
        this._readyObserver = null;
        this._controller = new AbortController();
        const signal = this._controller.signal;
        this.tabs = [...this.querySelectorAll('[data-tab]')];
        this.phones = [...this.querySelectorAll('[data-phone]')];
        if (this.tabs.length !== 3 || this.phones.length !== 3) { this._controller = null; return; }
        this.current = Number(this.dataset.active) || 0;
        this.paused = false;
        this.hovered = false;
        this.visible = false;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.tabs.forEach((tab, index) => tab.addEventListener('click', () => this.select(index, true), { signal }));
        const tablist = this.querySelector('[role=tablist]');
        this.mobile = window.matchMedia('(max-width: 749px)');
        const orient = () => tablist.setAttribute('aria-orientation', this.mobile.matches ? 'horizontal' : 'vertical');
        orient();
        this.mobile.addEventListener('change', orient, { signal });
        tablist.addEventListener('keydown', event => {
          let next;
          if (['ArrowRight', 'ArrowDown'].includes(event.key)) next = this.current + 1;
          if (['ArrowLeft', 'ArrowUp'].includes(event.key)) next = this.current - 1;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = 2;
          if (next !== undefined) { event.preventDefault(); this.select(next, true); this.tabs[this.current].focus(); }
        }, { signal });
        this.querySelector('[data-prev]').addEventListener('click', () => this.select(this.current - 1, true), { signal });
        this.querySelector('[data-next]').addEventListener('click', () => this.select(this.current + 1, true), { signal });
        this.querySelector('[data-pause]')?.addEventListener('click', () => {
          this.paused = !this.paused;
          this.updatePause();
          this.schedule();
        }, { signal });
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, { signal });
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, { signal });
        this.addEventListener('focusin', () => this.stop(), { signal });
        this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), { signal });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        this.reduced.addEventListener('change', () => this.schedule(), { signal });
        const stage = this.querySelector('.rap__stage');
        stage.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'touch' || !event.isPrimary) return;
          this.touch = { x:event.clientX, y:event.clientY };
        }, { signal });
        stage.addEventListener('pointerup', event => {
          if (!this.touch) return;
          const dx = event.clientX - this.touch.x;
          const dy = event.clientY - this.touch.y;
          this.touch = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) this.select(this.current + (dx < 0 ? 1 : -1), true);
        }, { signal });
        stage.addEventListener('pointercancel', () => { this.touch = null; }, { signal });
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.classList.add('rap--enter');
          this.schedule();
        }, { threshold:.12 });
        this.observer.observe(this);
        this.select(this.current);
      }
      select(index, manual = false) {
        this.current = (index + 3) % 3;
        this.dataset.active = this.current;
        this.tabs.forEach((tab, i) => {
          const active = i === this.current;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          const phone = this.phones[i];
          phone.dataset.position = active ? 'center' : (i === (this.current + 1) % 3 ? 'right' : 'left');
          phone.setAttribute('aria-hidden', String(!active));
          phone.inert = !active;
          phone.tabIndex = active ? 0 : -1;
        });
        this.querySelector('.rap__caption-index').textContent = `0${this.current + 1} / 03`;
        this.querySelector('.rap__caption-label').textContent = this.tabs[this.current].querySelector('.rap__tab-label').textContent;
        if (manual) { this.paused = true; this.updatePause(); }
        this.schedule();
      }
      updatePause() {
        this.querySelector('[data-pause]')?.setAttribute('aria-pressed', String(this.paused));
        const icon = this.querySelector('[data-pause-icon]');
        if (icon) icon.textContent = this.paused ? '▶' : 'Ⅱ';
      }
      stop() { clearTimeout(this.timer); }
      schedule() {
        this.stop();
        if (this.dataset.autoplay !== 'true' || this.dataset.motion !== 'true' || this.paused || this.hovered || !this.visible || this.reduced.matches || document.hidden || this.contains(document.activeElement) || window.Shopify?.designMode) return;
        this.timer = setTimeout(() => this.select(this.current + 1), 6000);
      }
      disconnectedCallback() {
        this._readyObserver?.disconnect();
        this._readyObserver = null;
        this.stop();
        this.observer?.disconnect();
        this._controller?.abort();
        this._controller = null;
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["npg-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  const registryKey = '__afpdSectionManagerV2';
  if (window[registryKey]) {
    window[registryKey].scan(document);
    return;
  }

  const instances = new WeakMap();

  function init(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const observers = [];
    const listen = (element, type, handler, options = {}) => {
      if (element) element.addEventListener(type, handler, { ...options, signal: controller.signal });
    };
    instances.set(root, () => {
      controller.abort();
      observers.forEach(observer => observer.disconnect());
      finishThumbDrag();
      instances.delete(root);
    });

    const mainImage = root.querySelector('.afpd__main-image');
    const thumbs = Array.from(root.querySelectorAll('.afpd__thumb'));
    const thumbsViewport = root.querySelector('.afpd__thumbs');
    let thumbDrag = null;
    let suppressThumbClick = false;

    function finishThumbDrag(event) {
      if (!thumbDrag || (event && event.pointerId !== thumbDrag.id)) return;
      const drag = thumbDrag;
      thumbDrag = null;
      if (drag.active) suppressThumbClick = true;
      if (thumbsViewport.hasPointerCapture(drag.id)) thumbsViewport.releasePointerCapture(drag.id);
      thumbsViewport.classList.remove('is-dragging');
    }

    listen(thumbsViewport, 'dragstart', event => event.preventDefault());
    listen(thumbsViewport, 'pointerdown', event => {
      suppressThumbClick = false;
      // Touch and pen keep the browser's native scrolling and vertical page gestures.
      if (event.pointerType !== 'mouse' || event.button !== 0 ||
          thumbsViewport.scrollWidth <= thumbsViewport.clientWidth + 2) return;
      thumbDrag = {
        id: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        startScroll: thumbsViewport.scrollLeft,
        active: false
      };
    });
    listen(window, 'pointermove', event => {
      if (!thumbDrag || event.pointerId !== thumbDrag.id) return;
      if (!(event.buttons & 1)) { finishThumbDrag(event); return; }
      const distance = event.clientX - thumbDrag.startX;
      if (!thumbDrag.active) {
        if (Math.abs(distance) < 6) return;
        if (Math.abs(event.clientY - thumbDrag.startY) > Math.abs(distance)) {
          thumbDrag = null;
          return;
        }
        thumbDrag.active = true;
        thumbsViewport.classList.add('is-dragging');
        thumbsViewport.setPointerCapture(event.pointerId);
      }
      event.preventDefault();
      thumbsViewport.scrollLeft = thumbDrag.startScroll - distance;
    });
    listen(window, 'pointerup', finishThumbDrag);
    listen(window, 'pointercancel', finishThumbDrag);
    listen(thumbsViewport, 'lostpointercapture', finishThumbDrag);
    listen(window, 'blur', () => finishThumbDrag());
    listen(thumbsViewport, 'click', event => {
      // A drag must never select the thumbnail under the mouse when released.
      if (!suppressThumbClick || event.detail === 0) return;
      suppressThumbClick = false;
      event.preventDefault();
      event.stopPropagation();
    }, { capture: true });

    if (thumbsViewport) {
      const onThumbResize = () => keepThumbInView(activeIndex);
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(onThumbResize);
        observer.observe(thumbsViewport);
        if (thumbs[0]) observer.observe(thumbs[0]);
        observers.push(observer);
      } else {
        listen(window, 'resize', onThumbResize);
      }
    }
    const prevArrow = root.querySelector('[data-gallery-prev]');
    const nextArrow = root.querySelector('[data-gallery-next]');
    let activeIndex = Math.max(0, thumbs.findIndex(thumb => thumb.classList.contains('is-active')));

    function updateGalleryArrows() {
      const states = [[prevArrow, activeIndex <= 0], [nextArrow, activeIndex >= thumbs.length - 1]];
      states.forEach(([arrow, atBoundary]) => {
        if (!arrow) return;
        const disabled = thumbs.length < 2 || atBoundary;
        arrow.classList.toggle('is-disabled', disabled);
        arrow.disabled = disabled;
        arrow.setAttribute('aria-disabled', String(disabled));
      });
    }

    function setMainImage(src, alt, width, height) {
      if (!mainImage || !src) return;
      mainImage.alt = alt || '';
      if (Number(width) > 0 && Number(height) > 0) {
        mainImage.setAttribute('width', width);
        mainImage.setAttribute('height', height);
      }
      mainImage.src = src;
    }

    function keepThumbInView(index, advanceFromEdge) {
      const thumb = thumbs[index];
      if (!thumb || !thumbsViewport) return;
      const viewportRect = thumbsViewport.getBoundingClientRect();
      const thumbRect = thumb.getBoundingClientRect();
      const tolerance = 2;
      const computed = window.getComputedStyle(thumbsViewport);
      const gap = parseFloat(computed.columnGap || computed.gap) || 0;
      const step = thumb.offsetWidth + gap;
      let distance = 0;
      if (thumbRect.left < viewportRect.left - tolerance) {
        distance = thumbRect.left - viewportRect.left;
      } else if (thumbRect.right > viewportRect.right + tolerance) {
        distance = thumbRect.right - viewportRect.right;
      } else if (advanceFromEdge && Math.abs(thumbRect.left - viewportRect.left) <= tolerance && index > 0) {
        distance = -step;
      } else if (advanceFromEdge && Math.abs(thumbRect.right - viewportRect.right) <= tolerance && index < thumbs.length - 1) {
        distance = step;
      }
      if (distance) {
        thumbsViewport.scrollBy({
          left: distance,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }
    }

    function activateThumb(index, advanceFromEdge = false) {
      if (!thumbs.length || !mainImage) return;
      activeIndex = Math.max(0, Math.min(index, thumbs.length - 1));
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === activeIndex);
        thumb.setAttribute('aria-pressed', String(i === activeIndex));
      });
      const thumb = thumbs[activeIndex];
      setMainImage(thumb.dataset.image, thumb.dataset.imageAlt, thumb.dataset.imageWidth, thumb.dataset.imageHeight);
      keepThumbInView(activeIndex, advanceFromEdge);
      updateGalleryArrows();
    }

    thumbs.forEach((thumb, index) => listen(thumb, 'click', () => activateThumb(index, true)));
    listen(prevArrow, 'click', () => { if (activeIndex > 0) activateThumb(activeIndex - 1); });
    listen(nextArrow, 'click', () => { if (activeIndex < thumbs.length - 1) activateThumb(activeIndex + 1); });
    updateGalleryArrows();
    keepThumbInView(activeIndex);
    listen(thumbsViewport, 'focusin', event => {
      const index = thumbs.indexOf(event.target.closest('.afpd__thumb'));
      if (index >= 0) keepThumbInView(index);
    });

    const form = root.querySelector('.afpd__form');
    const variantInput = form && form.querySelector('[name="id"]');
    const variantCards = Array.from(root.querySelectorAll('.afpd__variant-card'));
    const quantityInputs = Array.from(root.querySelectorAll('.afpd__qty-input'));
    const quantityInput = quantityInputs.find(input => input.name === 'quantity') || quantityInputs[0];
    let available = root.dataset.available === 'true';

    function quantityRules(input) {
      const min = Math.max(1, Number(input.min) || 1);
      const step = Math.max(1, Number(input.step) || 1);
      const limit = input.getAttribute('max');
      const rawMax = limit !== null && limit !== '' && Number.isFinite(Number(limit)) ? Number(limit) : Infinity;
      const max = rawMax === Infinity ? Infinity : min + Math.floor((rawMax - min) / step) * step;
      return { min, step, max };
    }

    function syncQuantity(source, emitChange) {
      if (!source) return;
      const { min, step, max } = quantityRules(source);
      let value = Number(source.value);
      if (!Number.isFinite(value) || value < min) value = min;
      value = min + Math.floor((value - min) / step) * step;
      if (Number.isFinite(max) && max >= min) value = Math.min(value, max);
      quantityInputs.forEach(input => {
        input.value = String(value);
        const group = input.closest('.afpd__qty');
        const minus = group && group.querySelector('[data-action="minus"]');
        const plus = group && group.querySelector('[data-action="plus"]');
        if (minus) minus.disabled = value <= min;
        if (plus) plus.disabled = value >= max;
      });
      if (emitChange && quantityInput) {
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    quantityInputs.forEach(input => {
      const group = input.closest('.afpd__qty');
      group.querySelectorAll('.afpd__qty-btn').forEach(button => {
        listen(button, 'click', () => {
          syncQuantity(input, false);
          const { step } = quantityRules(input);
          input.value = String(Number(input.value) + (button.dataset.action === 'plus' ? step : -step));
          syncQuantity(input, true);
        });
      });
      listen(input, 'change', () => {
        syncQuantity(input, input !== quantityInput);
      });
    });
    syncQuantity(quantityInput, false);

    function updateAvailability(value) {
      available = value;
      root.dataset.available = String(value);
      root.querySelectorAll('.afpd__payment-mount').forEach(mount => { mount.hidden = !value; });
      root.querySelectorAll('.afpd__sold-out').forEach(message => { message.hidden = value; });
    }

    function applyVariant(card, notify) {
      const variantId = card.dataset.variantId;
      variantCards.forEach(item => {
        const selected = item.dataset.variantId === variantId;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-pressed', String(selected));
      });
      if (variantInput) variantInput.value = variantId;
      root.querySelectorAll('.afpd__current-price').forEach(price => { price.textContent = card.dataset.variantPrice || ''; });
      root.querySelectorAll('.afpd__compare-price').forEach(price => {
        price.textContent = card.dataset.variantCompare || '';
        price.classList.toggle('is-hidden', !card.dataset.variantCompare);
      });
      updateAvailability(card.dataset.variantAvailable === 'true');
      quantityInputs.forEach(input => {
        input.min = card.dataset.quantityMin || '1';
        input.step = card.dataset.quantityStep || '1';
        if (card.dataset.quantityMax) input.max = card.dataset.quantityMax;
        else input.removeAttribute('max');
      });
      syncQuantity(quantityInput, false);

      if (card.dataset.variantImage) {
        const index = thumbs.findIndex(thumb => thumb.dataset.mediaId === card.dataset.variantMediaId);
        if (index >= 0) activateThumb(index);
        else setMainImage(card.dataset.variantImage, card.dataset.variantAlt, card.dataset.variantWidth, card.dataset.variantHeight);
      }
      if (notify && variantInput) {
        variantInput.dispatchEvent(new Event('input', { bubbles: true }));
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        if (quantityInput) quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    variantCards.forEach(card => listen(card, 'click', () => applyVariant(card, true)));
    listen(variantInput, 'change', () => {
      const card = variantCards.find(item => item.dataset.variantId === variantInput.value);
      if (card) applyVariant(card, false);
    });
    listen(form, 'submit', event => {
      syncQuantity(quantityInput, false);
      if (!available || !form.checkValidity()) {
        event.preventDefault();
        if (available) form.reportValidity();
      }
    });
    updateAvailability(available);

    // Legacy compatibility only. Modern accelerated checkout has a closed shadow DOM;
    // its labels/branding stay under Shopify's control.
    root.querySelectorAll('.afpd__dynamic[data-button-text]').forEach(wrapper => {
      const customText = (wrapper.dataset.buttonText || '').trim();
      if (!customText) return;
      const applyLegacyText = () => {
        const button = wrapper.querySelector('.shopify-payment-button__button--unbranded');
        if (button && button.textContent.trim() !== customText) button.textContent = customText;
      };
      applyLegacyText();
      const observer = new MutationObserver(applyLegacyText);
      observer.observe(wrapper, { childList: true, subtree: true, characterData: true });
      observers.push(observer);
    });
  }

  function rootsWithin(scope) {
    const roots = [];
    if (scope.matches && scope.matches('[data-afpd]')) roots.push(scope);
    if (scope.querySelectorAll) roots.push(...scope.querySelectorAll('[data-afpd]'));
    return roots;
  }
  function scan(scope) { rootsWithin(scope).forEach(init); }
  window[registryKey] = { scan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  } else {
    scan(document);
  }
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    rootsWithin(event.target).forEach(root => {
      const cleanup = instances.get(root);
      if (cleanup) cleanup();
    });
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smokpub-faq"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.SmokpubFaqBackdrop) return;

  // One controller per FAQ section; the FAQ element owns its lifecycle.
  class SmokpubFaqBackdrop {
    constructor(root) {
      this.root = root;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = true;
      this.x = this.targetX = 50;
      this.y = this.targetY = 22;
      this.raf = 0;
      this.lastTime = 0;
      this.destroyed = false;

      this.onPointerMove = event => {
        // Touch scrolling stays native; touch interaction is a single tap.
        if (event.pointerType === 'mouse' || event.pointerType === 'pen') this.setTarget(event);
      };
      this.onPointerDown = event => {
        if (event.pointerType === 'touch') this.setTarget(event);
      };
      this.onPointerLeave = event => {
        // A tap leaves its light in place; only a hovering pointer recenters.
        if (event.pointerType === 'touch') return;
        if (!this.canFollow()) return;
        this.targetX = 50;
        this.targetY = 22;
        this.schedule();
      };
      this.onVisibility = () => this.refresh();
      this.onMotion = () => {
        if (this.motion.matches) {
          this.x = this.targetX = 50;
          this.y = this.targetY = 22;
          this.paint();
        }
        this.refresh();
      };

      root.addEventListener('pointermove', this.onPointerMove, { passive: true });
      root.addEventListener('pointerdown', this.onPointerDown, { passive: true });
      root.addEventListener('pointerleave', this.onPointerLeave, { passive: true });
      document.addEventListener('visibilitychange', this.onVisibility);
      if (this.motion.addEventListener) this.motion.addEventListener('change', this.onMotion);
      else this.motion.addListener(this.onMotion);

      if ('IntersectionObserver' in window) {
        this.intersection = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.refresh();
        });
        this.intersection.observe(root);
      }
      this.attributes = new MutationObserver(() => this.refresh());
      this.attributes.observe(root, { attributes: true, attributeFilter: ['data-background-mode', 'data-gradient-follow'] });
      this.refresh();
    }

    canAnimate() {
      return !this.destroyed && this.root.isConnected && this.visible && !document.hidden && !this.motion.matches;
    }

    canFollow() {
      const mode = this.root.dataset.backgroundMode;
      return this.canAnimate() && this.root.dataset.gradientFollow === 'true' && (mode === 'spotlight' || mode === 'aurora');
    }

    refresh() {
      this.root.dataset.backgroundActive = String(this.canAnimate());
      if (!this.canFollow()) {
        this.cancel();
        return;
      }
      if (Math.abs(this.targetX - this.x) + Math.abs(this.targetY - this.y) > .05) this.schedule();
    }

    setTarget(event) {
      if (!this.canFollow()) return;
      const bounds = this.root.getBoundingClientRect();
      if (bounds.width < 1 || bounds.height < 1) return;
      this.targetX = Math.max(0, Math.min(100, (event.clientX - bounds.left) / bounds.width * 100));
      this.targetY = Math.max(0, Math.min(100, (event.clientY - bounds.top) / bounds.height * 100));
      this.schedule();
    }

    schedule() {
      if (!this.raf && this.canFollow()) this.raf = requestAnimationFrame(time => this.frame(time));
    }

    frame(time) {
      this.raf = 0;
      if (!this.canFollow()) { this.lastTime = 0; return; }
      const dt = Math.min(50, this.lastTime ? time - this.lastTime : 16);
      const factor = 1 - Math.exp(-dt / 115);
      this.x += (this.targetX - this.x) * factor;
      this.y += (this.targetY - this.y) * factor;
      this.lastTime = time;
      this.paint();
      if (Math.abs(this.targetX - this.x) + Math.abs(this.targetY - this.y) > .05) this.schedule();
      else this.lastTime = 0;
    }

    paint() {
      this.root.style.setProperty('--faq-light-x', this.x.toFixed(2) + '%');
      this.root.style.setProperty('--faq-light-y', this.y.toFixed(2) + '%');
    }

    cancel() {
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.lastTime = 0;
    }

    cleanup() {
      this.destroyed = true;
      this.cancel();
      this.intersection?.disconnect();
      this.attributes?.disconnect();
      this.root.removeEventListener('pointermove', this.onPointerMove);
      this.root.removeEventListener('pointerdown', this.onPointerDown);
      this.root.removeEventListener('pointerleave', this.onPointerLeave);
      document.removeEventListener('visibilitychange', this.onVisibility);
      if (this.motion.removeEventListener) this.motion.removeEventListener('change', this.onMotion);
      else this.motion.removeListener(this.onMotion);
      this.root.dataset.backgroundActive = 'false';
    }
  }

  window.SmokpubFaqBackdrop = SmokpubFaqBackdrop;
})();

(function () {
  'use strict';
  if (!window.customElements || customElements.get('smokpub-pan')) return;

  const DEFAULT_YAW = -Math.PI / 4;
  const ELEVATION = 0.68;
  const CAMERA_UP = Math.sqrt(1 - ELEVATION * ELEVATION);
  // Keep geometry in a theme asset so the Liquid section stays below 256 KB.
  const modelPromises = new Map();
  function loadSourceModel(source) {
    if (!source) return Promise.reject(new Error('Missing model asset URL'));
    const url = new URL(source, document.baseURI).href;
    if (!modelPromises.has(url)) {
      const promise = (async () => {
        if (!window.DecompressionStream) throw new Error('Model decompression unavailable');
        const encoded = await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.async = true;
          const cleanup = () => {
            clearTimeout(timer);
            script.onload = script.onerror = null;
            script.remove();
          };
          const timer = setTimeout(() => {
            cleanup();
            reject(new Error('Model asset load timed out'));
          }, 15000);
          script.onload = () => {
            const value = window.SmokpubPanModelData?.get(url);
            window.SmokpubPanModelData?.delete(url);
            cleanup();
            if (typeof value === 'string' && value.length) resolve(value);
            else reject(new Error('Invalid model asset'));
          };
          script.onerror = () => {
            cleanup();
            reject(new Error('Model asset could not load'));
          };
          document.head.appendChild(script);
        });
        const decoded = atob(encoded);
        const bytes = new Uint8Array(decoded.length);
        for (let i = 0; i < decoded.length; i++) bytes[i] = decoded.charCodeAt(i);
        const stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'));
        const buffer = await new Response(stream).arrayBuffer();
        if (!buffer.byteLength || buffer.byteLength % 132) throw new Error('Invalid model geometry');
        return new Float32Array(buffer);
      })();
      modelPromises.set(url, promise);
      promise.catch(() => {
        if (modelPromises.get(url) === promise) modelPromises.delete(url);
      });
    }
    return modelPromises.get(url);
  }
  const clamp = (value, low, high) => Math.max(low, Math.min(high, value));
  const wrap = angle => Math.atan2(Math.sin(angle), Math.cos(angle));
  const VERTEX = `
    attribute vec3 aPosition;
    attribute vec3 aNormal;
    attribute vec3 aColor;
    attribute vec2 aFinish;
    uniform mat4 uModel;
    uniform mat4 uProjection;
    varying vec3 vPosition;
    varying vec3 vNormal;
    varying vec3 vColor;
    varying vec2 vFinish;
    void main() {
      vec4 world = uModel * vec4(aPosition, 1.0);
      vPosition = world.xyz;
      vNormal = mat3(uModel) * aNormal;
      vColor = aColor;
      vFinish = aFinish;
      gl_Position = uProjection * world;
    }`;
  const FRAGMENT = `
    precision mediump float;
    varying vec3 vPosition;
    varying vec3 vNormal;
    varying vec3 vColor;
    varying vec2 vFinish;
    uniform vec3 uView;
    void main() {
      if (vFinish.x < 0.0) {
        gl_FragColor = vec4(vColor, 1.0);
        return;
      }
      vec3 n = normalize(vNormal);
      vec3 key = normalize(vec3(-3.5, 5.0, 4.2));
      vec3 fill = normalize(vec3(4.0, 3.0, -3.0));
      float diffuse = 0.48 + 0.78 * max(dot(n, key), 0.0)
                           + 0.28 * max(dot(n, fill), 0.0);
      float specular = pow(max(dot(n, normalize(key + uView)), 0.0), vFinish.x);
      float second = pow(max(dot(n, normalize(fill + uView)), 0.0), vFinish.x);
      float edge = pow(1.0 - max(dot(n, uView), 0.0), 3.0);
      float grain = fract(sin(dot(vPosition, vec3(133.1, 271.9, 97.3))) * 43758.5);
      vec3 color = vColor * diffuse * (0.97 + 0.06 * grain);
      color += vec3(0.91, 0.95, 1.0) * vFinish.y * (specular + 0.35 * second);
      color += vec3(0.044, 0.05, 0.06) * edge;
      gl_FragColor = vec4(color, 1.0);
    }`;

  function colorFromHex(value) {
    const hex = /^#[0-9a-f]{6}$/i.test(value || '') ? value : '#25272b';
    return [1, 3, 5].map(offset => parseInt(hex.slice(offset, offset + 2), 16) / 255);
  }

  function multiply(a, b) {
    const result = new Float32Array(16);
    for (let column = 0; column < 4; column++) {
      for (let row = 0; row < 4; row++) {
        for (let k = 0; k < 4; k++) result[column * 4 + row] += a[k * 4 + row] * b[column * 4 + k];
      }
    }
    return result;
  }

  function modelMatrix(yaw, tiltX, tiltZ) {
    const c = Math.cos(yaw), s = Math.sin(yaw);
    const x = Math.cos(tiltX), a = Math.sin(tiltX);
    const z = Math.cos(tiltZ), b = Math.sin(tiltZ);
    const ry = [c, 0, -s, 0, 0, 1, 0, 0, s, 0, c, 0, 0, 0, 0, 1];
    const rx = [1, 0, 0, 0, 0, x, a, 0, 0, -a, x, 0, 0, 0, 0, 1];
    const rz = [z, b, 0, 0, -b, z, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
    return multiply(multiply(rz, rx), ry);
  }

  class SmokpubPan extends HTMLElement {
    static get observedAttributes() { return ['data-color', 'data-follow', 'data-mobile-mode']; }

    connectedCallback() {
      this._mountToken = (this._mountToken || 0) + 1;
      this._initializing = false;
      this.setAttribute('aria-hidden', 'true');
      this._yaw = this._targetYaw = DEFAULT_YAW;
      this._tiltX = this._tiltZ = this._targetX = this._targetZ = 0;
      this._visible = false;
      this._lost = false;
      this._usingTouch = false;
      this._usingMouse = false;
      this._autoResume = 0;
      this._drag = null;
      this._boot = () => {
        if (!this.isConnected || this._canvas) return;
        const canvas = this.querySelector('[data-pan-canvas]');
        if (!canvas) return;
        this._children?.disconnect();
        this._canvas = canvas;
        this.dataset.renderState = 'fallback';
        this._connect();
      };
      this._children = new MutationObserver(this._boot);
      this._children.observe(this, { childList: true, subtree: true });
      this._boot();
    }

    _connect() {
      this._motion = matchMedia('(prefers-reduced-motion: reduce)');
      this._onMotion = () => { this._endTouch(); this._reset(true); };
      this._motion.addEventListener?.('change', this._onMotion);
      if (!this._motion.addEventListener) this._motion.addListener(this._onMotion);
      this._mobile = matchMedia('(hover: none), (pointer: coarse)');
      this._onMobile = () => { this._cancel(); this._dirty = true; this._schedule(); };
      this._mobile.addEventListener?.('change', this._onMobile);
      if (!this._mobile.addEventListener) this._mobile.addListener(this._onMobile);
      this._onPointer = event => {
        if (event.pointerType && event.pointerType !== 'mouse') return;
        this._usingTouch = false;
        this._usingMouse = true;
        if (!this._visible || !this._gl || this._lost || this._motion.matches || this.dataset.follow !== 'true') return;
        this._aimAt(event.clientX, event.clientY, true);
      };
      this._onTouchStart = event => {
        if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
        if (this._drag || !event.isPrimary || !this._visible || !this._gl || this._lost || this._motion.matches
          || this._mobileMode() === 'static') return;
        this._usingTouch = true;
        this._usingMouse = false;
        clearTimeout(this._autoTimer);
        this._autoTimer = 0;
        this._drag = { id: event.pointerId, x: event.clientX, y: event.clientY,
          yaw: this._targetYaw, width: Math.max(this.getBoundingClientRect().width, 160),
          onPan: event.composedPath().includes(this), axis: null };
      };
      this._onTouchMove = event => {
        const drag = this._drag;
        if (!drag || drag.id !== event.pointerId) return;
        const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
        if (!drag.axis) {
          if (Math.max(Math.abs(dx), Math.abs(dy)) < 8) return;
          drag.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }
        // touch-action: pan-y allows a vertical swipe to keep scrolling the page.
        if (drag.axis !== 'x' || !drag.onPan) return;
        this._targetYaw = wrap(drag.yaw + dx / drag.width * Math.PI * 2);
        this._targetX = 0;
        this._targetZ = clamp(dx / drag.width * .06, -.06, .06);
        this._schedule();
      };
      this._onTouchEnd = event => {
        const drag = this._drag;
        if (!drag || drag.id !== event.pointerId) return;
        // Commit a tap on release; a swipe or pointercancel must never aim the handle.
        const travel = Math.max(Math.abs(event.clientX - drag.x), Math.abs(event.clientY - drag.y));
        if (event.type === 'pointerup' && !drag.axis && travel < 8
          && !this._motion.matches && this._mobileMode() !== 'static') {
          this._aimAt(event.clientX, event.clientY);
        }
        this._endTouch();
      };
      this._onReset = () => {
        if (this._drag || this._usingTouch || this._mobile?.matches) this._endTouch();
        else this._reset();
      };
      this._onOut = event => {
        if ((!event.pointerType || event.pointerType === 'mouse') && event.relatedTarget === null) this._reset();
      };
      window.addEventListener('pointermove', this._onPointer, { passive: true });
      window.addEventListener('pointerdown', this._onPointer, { passive: true });
      window.addEventListener('pointerout', this._onOut, { passive: true });
      this._touchArea = this.closest('smokpub-faq') || this;
      this._touchArea.addEventListener('pointerdown', this._onTouchStart, { passive: true });
      window.addEventListener('pointermove', this._onTouchMove, { passive: true });
      window.addEventListener('pointerup', this._onTouchEnd, { passive: true });
      window.addEventListener('pointercancel', this._onTouchEnd, { passive: true });
      window.addEventListener('blur', this._onReset);
      this._onVisibility = () => {
        if (document.hidden) {
          this._drag = null;
          this._targetX = this._targetZ = 0;
          clearTimeout(this._autoTimer);
          this._autoTimer = 0;
          this._cancel();
        }
        else {
          const remaining = this._autoResume - performance.now();
          if (remaining > 0 && this._mobileMode() === 'auto' && !this._motion.matches) {
            this._autoTimer = setTimeout(() => { this._autoTimer = 0; this._schedule(); }, remaining);
          }
          this._dirty = true;
          this._schedule();
        }
      };
      document.addEventListener('visibilitychange', this._onVisibility);
      this._onLost = event => {
        event.preventDefault();
        this._lost = true;
        this._cancel();
        this.dataset.renderState = 'fallback';
      };
      this._onRestored = () => {
        this._releaseGPU();
        this._lost = false;
        if (this._visible) this._initialize();
      };
      this._canvas.addEventListener('webglcontextlost', this._onLost);
      this._canvas.addEventListener('webglcontextrestored', this._onRestored);
      this._onResize = () => { this._dirty = true; this._schedule(); };
      if (window.ResizeObserver) {
        this._resize = new ResizeObserver(this._onResize);
        this._resize.observe(this);
      } else window.addEventListener('resize', this._onResize, { passive: true });
      if (window.IntersectionObserver) {
        this._intersection = new IntersectionObserver(entries => {
          this._visible = entries[entries.length - 1].isIntersecting;
          if (this._visible) {
            if (!this._gl && !this._lost) this._initialize();
            this._dirty = true;
            this._schedule();
          } else this._cancel();
        }, { rootMargin: '60px' });
        this._intersection.observe(this);
      } else {
        this._visible = true;
        this._initialize();
      }
    }

    _initialize() {
      if (this._initializing || this._gl || !this._canvas || this._lost) return;
      this._initializing = true;
      const token = this._mountToken;
      loadSourceModel(this.dataset.modelSrc).then(mesh => {
        if (!this.isConnected || token !== this._mountToken || !this._canvas || this._lost) return;
        this._mesh = mesh;
        this._initializeGPU();
      }).catch(() => {
        if (token === this._mountToken && this.isConnected) this.dataset.renderState = 'fallback';
      }).finally(() => {
        if (token === this._mountToken) this._initializing = false;
      });
    }

    _initializeGPU() {
      try {
        const gl = this._canvas.getContext('webgl', { alpha: true, antialias: true, premultipliedAlpha: false });
        if (!gl) return;
        this._gl = gl;
        this._shaders = [];
        const compile = (type, source) => {
          const shader = gl.createShader(type);
          if (!shader) throw new Error('Shader allocation failed');
          this._shaders.push(shader);
          gl.shaderSource(shader, source);
          gl.compileShader(shader);
          if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) throw new Error('Shader compilation failed');
          return shader;
        };
        this._program = gl.createProgram();
        if (!this._program) throw new Error('Program allocation failed');
        gl.attachShader(this._program, compile(gl.VERTEX_SHADER, VERTEX));
        gl.attachShader(this._program, compile(gl.FRAGMENT_SHADER, FRAGMENT));
        gl.linkProgram(this._program);
        if (!gl.getProgramParameter(this._program, gl.LINK_STATUS)) throw new Error('Program linking failed');
        gl.useProgram(this._program);
        this._buffer = gl.createBuffer();
        if (!this._buffer) throw new Error('Buffer allocation failed');
        gl.bindBuffer(gl.ARRAY_BUFFER, this._buffer);
        this._upload();
        let offset = 0;
        [['aPosition', 3], ['aNormal', 3], ['aColor', 3], ['aFinish', 2]].forEach(([name, size]) => {
          const location = gl.getAttribLocation(this._program, name);
          if (location < 0) throw new Error('Missing shader attribute');
          gl.enableVertexAttribArray(location);
          gl.vertexAttribPointer(location, size, gl.FLOAT, false, 44, offset * 4);
          offset += size;
        });
        this._uniforms = ['uModel', 'uProjection', 'uView'].map(name => gl.getUniformLocation(this._program, name));
        gl.uniform3f(this._uniforms[2], 0, ELEVATION, CAMERA_UP);
        gl.enable(gl.DEPTH_TEST);
        gl.clearColor(0, 0, 0, 0);
        this._dirty = true;
        this._schedule();
      } catch (_) {
        this._releaseGPU();
        this.dataset.renderState = 'fallback';
      }
    }

    _upload() {
      let data = this._mesh;
      if (!data) throw new Error('Source model unavailable');
      if (this.dataset.color && this.dataset.color.toLowerCase() !== '#25272b') {
        data = data.slice();
        const tint = colorFromHex(this.dataset.color);
        const reference = colorFromHex('#25272b');
        for (let i = 0; i < data.length; i += 11) {
          if (Math.max(data[i + 6], data[i + 7], data[i + 8]) >= .35) continue;
          for (let channel = 0; channel < 3; channel++) {
            data[i + 6 + channel] = Math.min(1, data[i + 6 + channel] * tint[channel] / reference[channel]);
          }
        }
      }
      this._gl.bindBuffer(this._gl.ARRAY_BUFFER, this._buffer);
      this._gl.bufferData(this._gl.ARRAY_BUFFER, data, this._gl.STATIC_DRAW);
      this._count = data.length / 11;
    }

    _aimAt(clientX, clientY, tilt = false) {
      const rect = this.getBoundingClientRect();
      const dx = clientX - rect.left - rect.width / 2;
      const dy = clientY - rect.top - rect.height / 2 - (this._centerOffset || 0);
      // Invert the camera's vertical foreshortening so the projected handle points at the tap.
      if (Math.hypot(dx, dy) < (tilt ? 3 : 8)) return;
      this._targetYaw = -Math.atan2(dy / ELEVATION, dx);
      this._targetX = tilt ? clamp(-dy / Math.max(rect.height, 1) * .055, -.08, .08) : 0;
      this._targetZ = tilt ? clamp(dx / Math.max(rect.width, 1) * .055, -.08, .08) : 0;
      this._schedule();
    }

    _reset(immediate = false) {
      this._targetYaw = DEFAULT_YAW;
      this._targetX = this._targetZ = 0;
      if (immediate || this._motion?.matches) {
        this._yaw = DEFAULT_YAW;
        this._tiltX = this._tiltZ = 0;
      }
      this._dirty = true;
      this._schedule();
    }

    _mobileMode() {
      return ['auto', 'static'].includes(this.dataset.mobileMode) ? this.dataset.mobileMode : 'drag';
    }

    _endTouch() {
      this._drag = null;
      // Keep the user's final angle; only the small drag tilt settles back to level.
      this._targetX = this._targetZ = 0;
      this._dirty = true;
      clearTimeout(this._autoTimer);
      this._autoTimer = 0;
      if (this._mobileMode() === 'auto' && !this._motion?.matches) {
        this._autoResume = performance.now() + 1200;
        this._autoTimer = setTimeout(() => { this._autoTimer = 0; this._schedule(); }, 1200);
      }
      this._schedule();
    }

    _autoRotate(time) {
      return this._mobileMode() === 'auto' && ((this._mobile?.matches && !this._usingMouse) || this._usingTouch)
        && !this._motion.matches && !this._drag && time >= (this._autoResume || 0);
    }

    _schedule() {
      if (!this._raf && this.isConnected && this._visible && this._gl && !this._lost && !document.hidden) {
        this._raf = requestAnimationFrame(time => this._frame(time));
      }
    }

    _frame(time) {
      this._raf = 0;
      if (!this.isConnected || !this._visible || !this._gl || this._lost || document.hidden) return;
      const elapsed = Math.min(time - (this._lastTime || time - 16), 40);
      const auto = this._autoRotate(time);
      if (auto) this._targetYaw = wrap(this._targetYaw + elapsed / 25000 * Math.PI * 2);
      const factor = 1 - Math.exp(-elapsed / 82);
      const delta = wrap(this._targetYaw - this._yaw);
      this._yaw = wrap(this._yaw + delta * factor);
      this._tiltX += (this._targetX - this._tiltX) * factor;
      this._tiltZ += (this._targetZ - this._tiltZ) * factor;
      this._lastTime = time;
      const moving = Math.abs(delta) > .0005 || Math.abs(this._targetX - this._tiltX) > .0001
        || Math.abs(this._targetZ - this._tiltZ) > .0001;
      try {
        const gl = this._gl, rect = this.getBoundingClientRect();
        if (rect.width < 1 || rect.height < 1) return;
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        const width = Math.max(1, Math.round(rect.width * dpr));
        const height = Math.max(1, Math.round(rect.height * dpr));
        if (this._canvas.width !== width || this._canvas.height !== height) {
          this._canvas.width = width;
          this._canvas.height = height;
        }
        const halfHeight = Math.max(1.42, 1.82 / (width / height));
        const halfWidth = halfHeight * width / height;
        this._centerOffset = .11 * CAMERA_UP / halfHeight * rect.height / 2;
        const projection = new Float32Array([1 / halfWidth, 0, 0, 0,
          0, CAMERA_UP / halfHeight, -ELEVATION / 4, 0,
          0, -ELEVATION / halfHeight, -CAMERA_UP / 4, 0,
          0, -.11 * CAMERA_UP / halfHeight, 0, 1]);
        gl.viewport(0, 0, width, height);
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
        gl.useProgram(this._program);
        gl.uniformMatrix4fv(this._uniforms[0], false, modelMatrix(this._yaw, this._tiltX, this._tiltZ));
        gl.uniformMatrix4fv(this._uniforms[1], false, projection);
        gl.drawArrays(gl.TRIANGLES, 0, this._count);
        if (gl.getError() !== gl.NO_ERROR) throw new Error('WebGL draw failed');
        this.dataset.renderState = 'ready';
        this._dirty = false;
      } catch (_) {
        this._releaseGPU();
        this.dataset.renderState = 'fallback';
        return;
      }
      if ((moving || auto) && !this._motion.matches) this._schedule();
      else this._lastTime = 0;
    }

    attributeChangedCallback(name, before, after) {
      if (before === after) return;
      if (name === 'data-follow' && after !== 'true') this._reset(true);
      if (name === 'data-mobile-mode' && this._canvas) {
        this._endTouch();
        this._cancel();
        this._dirty = true;
        this._schedule();
      }
      if (name === 'data-color' && this._gl && !this._lost) {
        try { this._upload(); this._dirty = true; this._schedule(); }
        catch (_) { this._releaseGPU(); this.dataset.renderState = 'fallback'; }
      }
    }

    _cancel() {
      if (this._raf) cancelAnimationFrame(this._raf);
      this._raf = 0;
      this._lastTime = 0;
    }

    _releaseGPU() {
      this._cancel();
      if (this._gl) {
        if (this._buffer) this._gl.deleteBuffer(this._buffer);
        if (this._program) this._gl.deleteProgram(this._program);
        this._shaders?.forEach(shader => this._gl.deleteShader(shader));
      }
      this._gl = this._buffer = this._program = this._uniforms = null;
      this._shaders = [];
    }

    disconnectedCallback() {
      this._mountToken = (this._mountToken || 0) + 1;
      this._initializing = false;
      this._children?.disconnect();
      this._intersection?.disconnect();
      this._resize?.disconnect();
      window.removeEventListener('resize', this._onResize);
      window.removeEventListener('pointermove', this._onPointer);
      window.removeEventListener('pointerdown', this._onPointer);
      window.removeEventListener('pointerout', this._onOut);
      this._touchArea?.removeEventListener('pointerdown', this._onTouchStart);
      this._touchArea = null;
      window.removeEventListener('pointermove', this._onTouchMove);
      window.removeEventListener('pointerup', this._onTouchEnd);
      window.removeEventListener('pointercancel', this._onTouchEnd);
      window.removeEventListener('blur', this._onReset);
      document.removeEventListener('visibilitychange', this._onVisibility);
      this._motion?.removeEventListener?.('change', this._onMotion);
      if (this._motion && !this._motion.removeEventListener) this._motion.removeListener(this._onMotion);
      this._mobile?.removeEventListener?.('change', this._onMobile);
      if (this._mobile && !this._mobile.removeEventListener) this._mobile.removeListener(this._onMobile);
      clearTimeout(this._autoTimer);
      this._autoTimer = 0;
      this._drag = null;
      this._canvas?.removeEventListener('webglcontextlost', this._onLost);
      this._canvas?.removeEventListener('webglcontextrestored', this._onRestored);
      this._releaseGPU();
      this._canvas = null;
    }
  }

  customElements.define('smokpub-pan', SmokpubPan);
})();


(() => {
  if (!window.customElements || customElements.get('smokpub-faq')) return;

  class SmokpubFaq extends HTMLElement {
    constructor() {
      super();
      this.items = new Map();
      this.handleClick = this.handleClick.bind(this);
      this.handleToggle = this.handleToggle.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handleMotion = this.handleMotion.bind(this);
    }

    connectedCallback() {
      this._backdrop ||= new window.SmokpubFaqBackdrop(this);
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener?.('change', this.handleMotion);
      if (!this.motion.addEventListener) this.motion.addListener(this.handleMotion);
      this.addEventListener('click', this.handleClick);
      this.addEventListener('toggle', this.handleToggle, true);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);

      if ('ResizeObserver' in window) {
        this.resize = new ResizeObserver(() => {
          // Observe content, never the details box whose height is animating.
          this.items.forEach(state => {
            if (!state.animation) return;
            const height = this.targetHeight(state);
            if (Math.abs(height - state.endHeight) > 0.5) {
              this.setExpanded(state.item, state.expanded);
            }
          });
        });
      }
      // Also handle sections upgraded before their children finish parsing.
      this.childrenObserver = new MutationObserver(() => this.refreshItems());
      this.childrenObserver.observe(this, { childList: true, subtree: true });
      this.refreshItems();
    }

    refreshItems() {
      this.items.forEach(state => {
        if (this.contains(state.item)) return;
        this.releaseItem(state);
        this.items.delete(state.item);
      });
      this.querySelectorAll('[data-sp-faq-item]').forEach(item => {
        if (this.items.has(item) || item.closest('smokpub-faq') !== this) return;
        const summary = item.querySelector(':scope > .sp-faq__question');
        const answer = item.querySelector(':scope > .sp-faq__answer');
        if (!summary || !answer) return;
        const state = {
          item, summary, answer, expanded: item.open, animation: null,
          name: item.getAttribute('name'),
          ariaExpanded: summary.getAttribute('aria-expanded'),
          wasInert: answer.hasAttribute('inert')
        };
        this.items.set(item, state);
        // Keep native grouping in Liquid for no-JS use. JS owns animated closing.
        item.removeAttribute('name');
        this.syncState(state);
        this.resize?.observe(summary);
        this.resize?.observe(answer);
      });
      const firstOpen = Array.from(this.items.values()).find(state => state.expanded);
      if (firstOpen) this.closeOthers(firstOpen.item, false);
    }

    syncState(state) {
      state.item.dataset.expanded = String(state.expanded);
      state.summary.setAttribute('aria-expanded', String(state.expanded));
      state.answer.toggleAttribute('inert', !state.expanded);
    }

    targetHeight(state) {
      const border = getComputedStyle(state.item);
      return state.summary.getBoundingClientRect().height
        + (state.expanded ? state.answer.getBoundingClientRect().height : 0)
        + (parseFloat(border.borderTopWidth) || 0)
        + (parseFloat(border.borderBottomWidth) || 0);
    }

    cancelAnimation(state) {
      const animation = state.animation;
      state.animation = null;
      if (!animation) return;
      animation.onfinish = null;
      animation.cancel();
    }

    finish(state) {
      // Only hide the native details content after its closing animation ends.
      state.item.open = state.expanded;
      this.cancelAnimation(state);
      delete state.item.dataset.animating;
    }

    setExpanded(item, expanded, animate = true) {
      const state = this.items.get(item);
      if (!state) return;
      if (expanded) this.closeOthers(item, animate);
      // Sample the visible height BEFORE cancelling so rapid reversals never snap.
      const startHeight = item.getBoundingClientRect().height;
      this.cancelAnimation(state);
      state.expanded = expanded;
      this.syncState(state);

      if (!animate || this.motion.matches || typeof item.animate !== 'function' || document.hidden) {
        this.finish(state);
        return;
      }

      item.dataset.animating = '';
      item.open = true;
      const endHeight = this.targetHeight(state);
      if (Math.abs(endHeight - startHeight) < 0.5) {
        this.finish(state);
        return;
      }
      state.endHeight = endHeight;
      const fullDistance = Math.max(state.answer.getBoundingClientRect().height, 1);
      const duration = Math.max(100, Math.min(320, 320 * Math.abs(endHeight - startHeight) / fullDistance));
      const animation = item.animate(
        [{ height: startHeight + 'px' }, { height: endHeight + 'px' }],
        { duration, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'both' }
      );
      state.animation = animation;
      animation.onfinish = () => {
        if (state.animation === animation) this.finish(state);
      };
    }

    closeOthers(selected, animate = true) {
      if (this.dataset.singleOpen !== 'true') return;
      this.items.forEach(state => {
        if (state.item !== selected && state.expanded) this.setExpanded(state.item, false, animate);
      });
    }

    handleClick(event) {
      if (event.defaultPrevented || event.button !== 0 || !(event.target instanceof Element)) return;
      const summary = event.target.closest('.sp-faq__question');
      const state = summary && this.items.get(summary.parentElement);
      if (!state || state.summary !== summary) return;
      if (event.target.closest('a, button, input, select, textarea')) return;
      event.preventDefault();
      this.setExpanded(state.item, !state.expanded);
    }

    handleToggle(event) {
      const state = this.items.get(event.target);
      if (!state || (state.animation && state.item.open)) return;
      // Synchronize changes made by other theme scripts without replaying our own toggles.
      if (state.item.open !== state.expanded) this.setExpanded(state.item, state.item.open, false);
    }

    handleBlockSelect(event) {
      if (!(event.target instanceof Element) || !this.contains(event.target)) return;
      const item = event.target.closest('[data-sp-faq-item]');
      if (item) this.setExpanded(item, true);
    }

    handleMotion() {
      if (this.motion.matches) this.items.forEach(state => this.finish(state));
    }

    releaseItem(state) {
      this.finish(state);
      this.resize?.unobserve(state.summary);
      this.resize?.unobserve(state.answer);
      delete state.item.dataset.expanded;
      if (state.ariaExpanded === null) state.summary.removeAttribute('aria-expanded');
      else state.summary.setAttribute('aria-expanded', state.ariaExpanded);
      state.answer.toggleAttribute('inert', state.wasInert);
      if (state.name !== null) state.item.setAttribute('name', state.name);
    }

    disconnectedCallback() {
      this._backdrop?.cleanup();
      this._backdrop = null;
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('toggle', this.handleToggle, true);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.motion?.removeEventListener?.('change', this.handleMotion);
      if (this.motion && !this.motion.removeEventListener) this.motion.removeListener(this.handleMotion);
      this.childrenObserver?.disconnect();
      this.resize?.disconnect();
      this.items.forEach(state => this.releaseItem(state));
      this.items.clear();
    }
  }

  customElements.define('smokpub-faq', SmokpubFaq);
})();


  } catch(e) { console.error(e); }
})();
})();
